function _toggleState($element, stateOne = '1', stateTwo = '0') {
  $element.setAttribute('data-state', $element.getAttribute('data-state') === stateOne ? stateTwo : stateOne);
}


function _replaceSpacesInTextCZ(text) {
  // check if variable is string
  if ( Object.prototype.toString.call(text) !== "[object String]" )
    return false;

  const regex = /(?<=\s[aiouksvz])\s/gi;
  const newText = text.replace(regex, '&nbsp;');

  return newText;

};

export {
  // _listen,
  _toggleState,
  _replaceSpacesInTextCZ,
};
